import React from 'react';

export default function Header({ theme, onThemeToggle }) {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-title">Semantic Diff Tool</h1>
          <p className="header-subtitle">
            Compare JSON, XML, and CSV with semantic analysis
          </p>
        </div>

        <div className="header-right">
          <button
            className="theme-toggle"
            onClick={onThemeToggle}
            aria-label="Toggle theme"
            title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
        </div>
      </div>
    </header>
  );
}
